import { MetricConverter } from './helpers';

const VoltageUnits = ['mV', 'V', 'kV'] as const;
export type TVoltageUnit = (typeof VoltageUnits)[number];

class VoltageConverter extends MetricConverter<TVoltageUnit, 'V'> {
    baseUnit = 'V' as const;
    units = VoltageUnits;
}

export const voltageConverter = new VoltageConverter();
